import VueFormWizard from '@/components/main.vue';

export default VueFormWizard;
